module.exports = __webpack_public_path__ + "static/media/twitter.4c98f76e.svg";